import React, { useEffect } from "react";

import getContentById from "../../../../shared/utils/getContentById";
import _ from "lodash";
import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, {
  animationCleanUp,
} from "./animations";

import configFrontend from "../../../../../config/frontend";

import assets from "./assets";
import { format as dateFormat } from "date-fns";

import { de, enUS } from "date-fns/locale";
import getOptaCountryCode from "../../../../shared/utils/getOptaCountryCode";
import { utcToZonedTime } from "date-fns-tz";
import countries from "../../../../../language/de/countries.json";
import { useTranslation } from "react-i18next";
import Image from "../../../../shared/components/Image";
import {
  getDynamicLogoPath,
  toIsoDateString,
} from "../../../../shared/utils/functions";
import {
  getDateInZone,
  getTimeInZone,
} from "../../../../shared/utils/dateHelpers";
import { WcBgCircle } from "../../../../shared/backgrounds/WcBgCircle/Index";
import ProgressBar from "../../../../shared/components/ProgressBar";
import { globalAssets } from "../../../assets/global/assets";
import MirrorBarChart from "../../../../shared/components/MirrorBarChart";
// import outroVideo9x16 from "../../../assets/outros/outro_playoffs_9x16.webm";

require("./style/style.scss");
require("./style/animation.scss");

const translations = {
  Group: "Gruppe",
};

const Index = (props) => {
  const refs = {
    player: React.createRef(),
    team: React.createRef(),
  };

  const {
    animation,
    data,
    images: Images,
    apiSetup,
    mode,
    format,
    isTimeline,
  } = props;

  const id = `${_.get(data, "template_name", "")}_${_.get(data, "uuid", "")}`;

  const { t, i18n } = useTranslation();

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          refs,
          data,
          animation,
          mode,
          id,
          format,
          apiSetup,
          templateName: data?.template_name,
        });
      }
    }

    //handle outro video BEGIN
    // if(mode === "video" && !isTimeline) {
    //   const outroVideo = $(`#${id} video.outro-optional-video`);
    //   outroVideo.get(0).addEventListener("loadedmetadata", function() {
    //       const that = this;
    //       setTimeout(()=> {
    //         outroVideo?.css('opacity', 1);
    //         this.currentTime = 0;
    //         that.play();
    //       }, frontendCfg.showOutroAfter)
    //     }, false);
    // }
    //handle outro video END

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const templateData = _.get(data, "data");

  const lng = i18n?.language;

  const { options, fields, dynamic } = templateData;
  const color1 = getContentById("color1", options);
  const color2 = getContentById("color2", options);

  const headerEn = getContentById("headline-en", fields);
  const headerDe = getContentById("headline-de", fields);
  const textDe = getContentById("text-de", fields);
  const textEn = getContentById("text-en", fields);
  const openerType = getContentById("openerType", fields);

  const teamHome = _.get(dynamic, "assets.teamHome");
  const teamAway = _.get(dynamic, "assets.teamAway");
  const event = data?.event;
  // const nextGame = _.get(dynamic, "nextGame");
  const matchInfo = _.get(dynamic, "matchInfo");
  // const teamDataStyles = _.get(teamData, "styles", {});

  // const thisGameDateTmp = new Date(toIsoDateString(matchInfo?.date, matchInfo?.time)) || '';

  // const timeZone = 'Europe/Berlin';
  // const thisGameDate = utcToZonedTime(thisGameDateTmp, timeZone);

  const feedType = _.get(data, "event.feedType", "opta");

  const isValidDate = Boolean(matchInfo?.date);

  const isoMatchDate = toIsoDateString(matchInfo?.date, matchInfo?.time);
  const matchDate = matchInfo?.time
    ? new Date(isoMatchDate)
    : new Date(matchInfo?.date);
  const time = matchInfo?.time ? getTimeInZone(matchDate, lng, true) : "-:-";
  const date = matchInfo?.time ? getDateInZone(matchDate, lng) : "-";
  let competitionId = dynamic?.matchInfo?.competition?.id;

  if (feedType === "heimspiel") {
    competitionId = "olympic_2024";
  }

  const backgroundImage = getMainBackground(format, _.get(dynamic, "teamSide"));

  const homeTeam = matchInfo?.contestant?.[0];
  const awayTeam = matchInfo?.contestant?.[1];
  const goalData = _.get(dynamic, "goalData");
  const maxAValue = Math.max(
    ...goalData?.flatMap(d => [d.teamA ?? 0])
  );
  const maxBValue = Math.max(
    ...goalData?.flatMap(d => [d.teamB ?? 0])
  );
  const maxValue = Math.max(
    ...goalData?.flatMap(d => [d.teamA ?? 0, d.teamB ?? 0])
  );
  const allValues = goalData.flatMap(d => [d.teamA ?? 0, d.teamB ?? 0]);

  // Sort for percentile logic
  const sorted = [...allValues].sort((a, b) => a - b);

  // 90th percentile (you can adjust to 85 or 95 depending on how aggressive you want)
  const percentileIndex = Math.floor(sorted.length * 0.9);
  const _threshold = sorted[percentileIndex] ?? 0;

  // Optional: compression factor (0.3 means values above threshold grow slower)
  const compressFactor = 0.3;

  // Soft-cap helper
  const softCapValue = (value, threshold = _threshold) => {
    if (value <= threshold) return value;
    return threshold + (value - threshold) * compressFactor;
  };

  // Apply soft-cap to all values
  const cappedValues = allValues.map(v => softCapValue(v, _threshold));

  // Use capped max for scaling
  const maxCapped = Math.max(...cappedValues);
  const oneLineHeight = 250 / maxCapped;

  // const oneLineHeight = 250 / maxValue ?? 30;
  const firstHalfAValues = goalData?.slice(0, 3).flatMap(d => [d.teamA])
  const firstHalfBValues = goalData?.slice(0, 3).flatMap(d => [d.teamB])
  const secondHalfAValues = goalData?.slice(3).flatMap(d => [d.teamA])
  const secondHalfBValues = goalData?.slice(3).flatMap(d => [d.teamB])
  return (
    <div
      id={id}
      className={`T_${_.get(data, "template_name", "")} ${animation ? "animation" : ""} side-${_.get(dynamic, "teamSide")}`}
    >
      <TemplateBlock>
        <Backgrounds bg1={backgroundImage} loop={true} />

        <div className={"wc-content wc-content-v2"}>
          <ProgressBar height={"8px"} />

          <div className={"qatar-logo"}>
            <img src={globalAssets.of_logo} />
          </div>

          <div className={"main-header"}>
            Goals over season
          </div>

          <div className="main-content">
            <div className="team-info-container">
              <div className={"team-logo-container home"}>
                <Image
                  className="team-logo"
                  src={getDynamicLogoPath({ team: homeTeam, competitionId })}
                />
              </div>
              <div className={"team-logo-container away"}>
                <Image
                  className="team-logo"
                  src={getDynamicLogoPath({ team: awayTeam, competitionId })}
                />
              </div>
            </div>
            <div className="goals-first-half-container">
              <div
                className="team-A-container"
                style={{
                  // height: `${maxAValue * oneLineHeight}px`
                }}
              >
                {
                  firstHalfAValues?.map((value) => {
                    const opacity = value / maxAValue;
                    return <div
                      data-height={softCapValue(value) * oneLineHeight}
                      className="score-container team-A"
                      style={{
                        background: `rgba(201,0,37,${opacity})`,
                        height: softCapValue(value) * oneLineHeight
                      }}>
                      <span>{value}</span>
                    </div>
                  })
                }
              </div>
              <div className="time-series-container" style={{
                // top: `${maxAValue * oneLineHeight + 45}px`
              }}>
                <span>0'</span>
                <div className="time-line first" />
                <span>15'</span>
                <div className="time-line" />
                <span>30'</span>
                <div className="time-line" />
                <span>45'</span>
              </div>
              <div
                className="team-B-container"
                style={{
                  // height: `${maxBValue * oneLineHeight}px`
                }}
              >
                {
                  firstHalfBValues?.map((value) => {
                    const opacity = value / maxBValue;
                    return <div
                      className="score-container team-A"
                      data-height={softCapValue(value) * oneLineHeight}
                      style={{
                        background: `rgba(104,181,251,${opacity})`,
                        height: softCapValue(value) * oneLineHeight
                      }}>
                      <span>{value}</span>
                    </div>
                  })
                }
              </div>
            </div>
            <div className="goals-second-half-container">
              <div
                className="team-A-container"
                style={{
                  // height: `${maxAValue * oneLineHeight}px`
                }}
              >
                {
                  secondHalfAValues?.map((value) => {
                    const opacity = value / maxAValue;
                    return <div
                      data-height={softCapValue(value) * oneLineHeight}
                      className="score-container team-A"
                      style={{
                        background: `rgba(201,0,37,${opacity})`,
                        height: softCapValue(value) * oneLineHeight
                      }}
                    >
                      <span>{value}</span>
                    </div>
                  })
                }
              </div>
              <div className="time-series-container" style={{
                // top: `${maxAValue * oneLineHeight + 45}px`
              }}>
                <div className="time-line first" />
                <span>60'</span>
                <div className="time-line" />
                <span>75'</span>
                <div className="time-line" />
                <span>90'</span>
              </div>
              <div
                className="team-B-container"
                style={{
                  // height: `${maxBValue * oneLineHeight}px`
                }}
              >
                {
                  secondHalfBValues?.map((value) => {
                    const opacity = value / maxBValue;
                    return <div
                      data-height={softCapValue(value) * oneLineHeight}
                      className="score-container team-A"
                      style={{
                        background: `rgba(104,181,251,${opacity})`,
                        height: softCapValue(value) * oneLineHeight
                      }}
                    >
                      <span>{value}</span>
                    </div>
                  })
                }
              </div>
            </div>
          </div>
        </div>
      </TemplateBlock>
    </div>
  );
};

const getMainBackground = (format, side) => {
  return _.get(assets, `background_1920`);
};

export default Index;
